import { TemplateRouter } from "#/components/templates/TemplateRouter.js";
import type { IndexPageProps } from "#/lib/templates/types.js";

export { Page };

function Page(props: IndexPageProps) {
  const commandCenterProps = { ...props, templateId: "bento-console" as const };
  return <TemplateRouter {...commandCenterProps} />;
}
